module.exports = __webpack_public_path__ + "static/media/bgo.7b001de8.png";